import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import sliderInput from '@/components/mapv2/sliderinput';
import { mapMutations } from 'vuex';
export default {
  props: {
    // 名称
    name: {
      type: String,
      default: ''
    },
    showWidth: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: {}
    }
  },
  components: {
    sliderInput
  },
  data() {
    return {
      pArr: [{
        icon: 'icon-lefttop',
        type: 'left-top'
      }, {
        icon: 'icon-leftbottom',
        type: 'left-bottom'
      }, {
        icon: 'icon-righttop',
        type: 'right-top'
      }, {
        icon: 'icon-rightbottom',
        type: 'right-bottom'
      }],
      pIndex: 0,
      ptype: 'left-top',
      pos: {
        left: 0,
        right: 0,
        bottom: 0,
        top: 0
      },
      ptypeArr: [{
        name: '左',
        type: 'left'
      }, {
        name: '右',
        type: 'right'
      }, {
        name: '上',
        type: 'top'
      }, {
        name: '下',
        type: 'bottom'
      }],
      max: 1920,
      width: 240,
      style: {}
    };
  },
  watch: {
    value: {
      handler(val) {
        if (Object.keys(val).length > 0) {
          this.commonHandle(val);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.value).length === 0) {
        this.changeHandle(this.pArr[0], 0);
      } else {
        this.commonHandle(this.value);
      }
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSTYLEITEM', 'SET_MAPSTYLE']),
    commonHandle(val) {
      this.style = {};
      this.pIndex = val.pIndex;
      this.ptype = val.ptype;
      this.style.pIndex = val.pIndex;
      this.style.ptype = val.ptype;
      Object.keys(this.pos).forEach(child => {
        Object.keys(val).forEach(item => {
          if (child === item) {
            this.pos[item] = parseInt(val[item]);
            this.style[item] = `${this.pos[item]}px`;
          }
        });
      });
      if (val.width) {
        this.style.width = `${parseInt(val.width)}px`;
        this.width = parseInt(val.width);
      }
      let obj = {};
      obj[this.name] = this.style;
      this.SET_MAPSTYLEITEM(obj);
    },
    // 选择快捷定位
    changeHandle(item, index) {
      this.pIndex = index;
      this.ptype = item.type;
      this.style.pIndex = index;
      this.style.ptype = item.type;
      this.width = parseInt(this.style.width);
      Object.keys(this.pos).forEach(child => {
        delete this.style[child];
      });
      let ptypeArr = this.ptype.split('-');
      ptypeArr.forEach(child => {
        this.style[child] = 0;
        this.pos[child] = 0;
      });
      let obj = {};
      obj[this.name] = this.style;
      this.SET_MAPSTYLEITEM(obj);
    },
    inputChange(val, type) {
      this.updateChange({
        name: type,
        value: val ? val + 'px' : 0
      });
    },
    inputNumberChange(val, type) {
      this.updateChange({
        name: type,
        value: val ? val + 'px' : 0
      });
    },
    updateChange(val) {
      this.style[val.name] = val.value;
      let obj = {};
      obj[this.name] = this.style;
      this.SET_MAPSTYLEITEM(obj);
    }
  }
};